import { Injectable } from '@angular/core';

declare var $: any;

@Injectable()
export class VMsg_ja_JP {
static load() {

/*
 * Translated default messages for the jQuery validation plugin.
 * Locale: JA (Japanese; 日本語)
 */
$.extend( $.validator.messages, {
	required: "このフィールドは必須です。",
	remote: "このフィールドを修正してください。",
	email: "有効なEメールアドレスを入力してください。",
	url: "有効なURLを入力してください。",
	date: "有効な日付を入力してください。",
	dateISO: "有効な日付（ISO）を入力してください。",
	number: "有効な数字を入力してください。",
	digits: "数字のみを入力してください。",
	creditcard: "有効なクレジットカード番号を入力してください。",
	equalTo: "同じ値をもう一度入力してください。",
	extension: "有効な拡張子を含む値を入力してください。",
	maxlength: $.validator.format( "{0} 文字以内で入力してください。" ),
	minlength: $.validator.format( "{0} 文字以上で入力してください。" ),
	rangelength: $.validator.format( "{0} 文字から {1} 文字までの値を入力してください。" ),
	range: $.validator.format( "{0} から {1} までの値を入力してください。" ),
	max: $.validator.format( "{0} 以下の値を入力してください。" ),
	min: $.validator.format( "{0} 以上の値を入力してください。" ),
	step: $.validator.format( "{0}の倍数を入力してください。" ),
	accept: "有効なファイルを選択してください。",
	alphanumeric: "英数字を入力してください。",
	integer: "整数を入力してください。",
	ipv4: "IPv4アドレスを入力してください。",
	ipv6: "IPv6アドレスを入力してください。",
	lettersonly: "英字を入力してください。",
	letterswithbasicpunc: "英字と記号を入力してください。",
	notEqualTo: "違う文字を入力してください。",
	nowhitespace: "スペースを入力しないでください。",
	pattern: $.validator.format( "有効なフォーマットを入力してください ({0})。" ),
	time: "有効な時刻を入力してください。",
	url2: "有効なURLを入力してください。",
	minbytelength: $.validator.format( "{0} バイト以上で入力してください。" ),
	maxByteLength: $.validator.format( "{0} バイト以内で入力してください。" ),
	rangeByteLength: $.validator.format( "{0} バイトから {1} バイトまでの文字を入力してください。" ),
	halfWidth: "半角のみを入力してください。" ,
	fullWidth: "全角のみを入力してください。" ,
	kanji: "漢字のみを入力してください。" ,
	kana: "仮名のみを入力してください。" ,
	hiragana: "ひらがなのみを入力してください。" ,
	katakana: "カタカナのみを入力してください。" ,
	halfKatakana: "半角カタカナのみを入力してください。" ,
	fullKatakana: "全角カタカナのみを入力してください。" ,
	date_yyyyMMdd: "有効な日付を入力してください (yyyyMMdd)。" ,
	date_yyyy_MM_dd: "有効な日付を入力してください (yyyy/MM/dd)。" ,
	date_yyyy_MM: "有効な年月を入力してください (yyyy/MM)。" ,
	date_yyyyMM: "有効な年月を入力してください (yyyyMM)。" ,
	date_MM_dd: "有効な日付を入力してください (MM/dd)。" ,
	date_MMdd: "有効な日付を入力してください (MMdd)。" ,
	time_HH_mm: "有効な時刻を入力してください (HH:mm)。" ,
	time_HH_mm_ss: "有効な時刻を入力してください (HH:mm:ss)。" ,
	time_HHmmss: "有効な時刻を入力してください (HHmmss)。" ,
	phoneJP: "有効な電話番号を入力してください。" ,
	mobileJP: "有効な携帯番号を入力してください。",
	numberLessThen: "小さい数字を入力してください。",
	numberLessEqualTo: "同じまたは小さい数字を入力してください。",
	dateLessThen: "早い日時を指定してください。",
	dateLessEqualTo: "同じまたは早い日時を指定してください。",
	pwd: "数字、英字と半角記号[@#$%]三種類の文字を入力してください。"
} );
}
}


// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/resources/validate_ja-JP.ts